<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account-hard-hat"
          inline
          class="px-5 py-3"
          style="min-height: 300px"
          :title="`Códigos da Distribuidora :: ${company.name}`"
        >
          <v-row class="mt-5">
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                Aqui você pode informar ao sistema quais são os códigos da distribuidora {{ company.name }}.
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field v-model="codigo_dist_sigr" label="Código DIST (SIG-R)" outlined maxlength="10" />
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="agente" label="Código DIST (SARI)" outlined maxlength="10" />
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="codigo" label="Código interno na distribuidora" outlined maxlength="10" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="codigos_padronizacao_uc"
                :search-input.sync="codigoDigitado"
                label="Códigos da distribuidora aceitos no ID padronizado da UC (N5N4N3)"
                hint="Digite o código (1 a 999) e pressione Enter. Informe mais de um em caso de fusão ou incorporação de distribuidoras."
                persistent-hint
                :rules="[validarCodigosPadronizacaoUc]"
                :delimiters="[',', ' ', ';']"
                multiple
                small-chips
                deletable-chips
                outlined
                @blur="adicionarCodigoDigitado"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-expansion-panels class="mb-8">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Consultar códigos das distribuidoras (Anexo I — Manual ANEEL de Padronização do ID da UC)
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-text-field
                      v-model="pesquisaSigla"
                      label="Pesquisar por sigla"
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      hide-details
                      outlined
                      dense
                      class="mb-3"
                    />
                    <v-data-table
                      :headers="headersDistribuidorasAneel"
                      :items="distribuidorasAneel"
                      :search="pesquisaSigla"
                      :custom-filter="filtrarPorSigla"
                      :items-per-page="10"
                      :loading="loadingDistribuidorasAneel"
                      no-results-text="Nenhuma distribuidora encontrada."
                      dense
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="primary"
                min-width="100"
                style="float: right"
                class="mr-0 mt-n5"
                :disabled="btnSaveDisabled"
                :loading="loading"
                @click="save()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CompanyService from '@/services/CompanyService';
  import AgenteService from '@/services/AgenteService';
  import DistribuidorasAneelService from '@/services/DistribuidorasAneelService';
  import routes from '@/store/modules/routes';

  export default {
    name: 'Agentes',
    data: () => ({
      company: { name: '' },
      codigo: '',
      agente: '',
      codigo_dist_sigr: '',
      codigos_padronizacao_uc: [],
      codigoDigitado: null,
      distribuidorasAneel: [],
      headersDistribuidorasAneel: [
        { text: 'Sigla', value: 'sigla' },
        { text: 'Código (N5N4N3)', value: 'codigo' }
      ],
      pesquisaSigla: '',
      loadingDistribuidorasAneel: false,
      loading: false
    }),
    computed: {
      btnSaveDisabled() {
        return !this.agente.length || this.validarCodigosPadronizacaoUc(this.codigos_padronizacao_uc) !== true;
      }
    },
    mounted() {
      this.getCompany(this.$route.params.id);
      this.getAgentes(this.$route.params.id);
      this.getDistribuidorasAneel();
    },
    methods: {
      getDistribuidorasAneel() {
        this.loadingDistribuidorasAneel = true;
        DistribuidorasAneelService.listar()
          .then(({ data }) => (this.distribuidorasAneel = data.data))
          .catch(() =>
            this.$toast.error('Erro ao buscar os códigos das distribuidoras.', '', {
              position: 'topRight'
            })
          )
          .finally(() => (this.loadingDistribuidorasAneel = false));
      },
      filtrarPorSigla(value, search, item) {
        return item.sigla.toLowerCase().includes(search.toLowerCase());
      },
      adicionarCodigoDigitado() {
        const codigo = (this.codigoDigitado ?? '').trim();
        if (codigo && !this.codigos_padronizacao_uc.includes(codigo)) {
          this.codigos_padronizacao_uc.push(codigo);
        }
        this.codigoDigitado = null;
      },
      validarCodigosPadronizacaoUc(codigos) {
        const invalidos = codigos.filter((codigo) => !/^\d{1,3}$/.test(codigo) || Number(codigo) === 0);
        return !invalidos.length || `Código(s) inválido(s): ${invalidos.join(', ')}. Use números de 1 a 999.`;
      },
      getAgentes(id) {
        AgenteService.getAgenteSelected(id)
          .then(({ data }) => {
            this.codigo = data.codigo;
            this.agente = data.agente;
            this.codigo_dist_sigr = data.codigo_dist_sigr;
            this.codigos_padronizacao_uc = data.codigos_padronizacao_uc ?? [];
          })
          .catch(() =>
            this.$toast.error('Erro ao buscar os dados do agente.', '', {
              position: 'topRight'
            })
          );
      },
      getCompany(id) {
        CompanyService.getCompanyById(id)
          .then((response) => (this.company.name = response.name))
          .catch(() =>
            this.$toast.error('Erro ao buscar os dados da empresa.', '', {
              position: 'topRight'
            })
          );
      },
      save() {
        this.adicionarCodigoDigitado();
        if (this.validarCodigosPadronizacaoUc(this.codigos_padronizacao_uc) !== true) {
          return;
        }
        this.loading = true;
        const data = {
          empresa: this.$route.params.id,
          codigo: this.codigo,
          agente: this.agente,
          codigo_dist_sigr: this.codigo_dist_sigr,
          codigos_padronizacao_uc: this.codigos_padronizacao_uc
        };
        AgenteService.save(data)
          .then(() => {
            this.$toast.success('Agentes configurados com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['EMPRESAS_LISTAR']
            });
          })
          .catch(() =>
            this.$toast.error('Erro ao salvar o agente para a empresa.', '', {
              position: 'topRight'
            })
          )
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
